<template>
  <modal
    v-slot="{ data }"
    name="managePaymentMethodModal"
    modal-style="compact"
    close-on-hide
  >
    <card-scanning-management :payment-method="data.paymentMethod" />
  </modal>
</template>


<script>
  import CardScanningManagement from './card-scanning-management/index.vue';


  export default {
    name: 'CardScanningManagementModal',

    components: {
      CardScanningManagement
    }
  };
</script>
